import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const invoicingHoldsReasonsAdapter = getAdapter({ idFieldName: 'value' });

const invoicingHoldsReasonsSlice = createSlice({
  name: 'invoicingHoldsReasons',
  initialState: invoicingHoldsReasonsAdapter.getInitialState(),
  reducers: {
    setInvoicingHoldsReasons: (state, { payload: { invoicingHoldsReasons } }) => {
      invoicingHoldsReasonsAdapter.setAll(state, invoicingHoldsReasons);
    },
  },
});

const selectors = invoicingHoldsReasonsAdapter.getSelectors(({ invoicingHoldsReasons }) => invoicingHoldsReasons);

export const getInvoicingHoldsReasons = (state) => selectors.selectAll(state);

export const {
  setInvoicingHoldsReasons,
} = invoicingHoldsReasonsSlice.actions;

export default invoicingHoldsReasonsSlice.reducer;
